import { Component, Input } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-total-balance',
    templateUrl: './total-balance.component.html',
    styleUrls: ['./total-balance.component.scss']
})
export class TotalBalanceComponent extends BaseComponent<BaseState> {

    @Input() Currency: string;
    @Input() Title: string;
    @Input() Amount: number;
    @Input() Icon: string;
    @Input() Color: string;

    constructor(A: ServiceBagService) {
        super(A, 'TotalBalanceComponent', BaseState);
    }
}
